module.exports = __webpack_public_path__ + "static/img/shop_storage_2.0bf6d19c.jpg";